import { render, staticRenderFns } from "./btnVoltar.vue?vue&type=template&id=0796dcba"
import script from "./btnVoltar.vue?vue&type=script&lang=js"
export * from "./btnVoltar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports